module.exports = __webpack_public_path__ + "images/panorama-360-2-3f1eea476e23c32ed5071ff5afb98c74.jpg";